import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { DeviceDetectorService } from 'ngx-device-detector';
import { LocalStorageService } from 'angular-2-local-storage';
import { IDateRangePickerOptions } from 'ngx-daterange';
import { AbstractControl, FormBuilder, Validators } from '@angular/forms';

import { ToastrService } from 'ngx-toastr';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-forgotpassword',
  templateUrl: './forgotpassword.component.html',
  styleUrls: ['./forgotpassword.component.css']
})
export class ForgotpasswordComponent implements OnInit {
  initialValue: any;
  model_isactive = '2';
  btnname = 'Save';
  showParentMenu = false;
  dropdownSettingscourselist: IDropdownSettings;
  testdata = [];
  show1 = false;
  show2 = false;
  options: IDateRangePickerOptions;
  showUpdate = false;
  opd = 0;
  formGroup: any;
  remainingTime: number;
  minutes: number;
  seconds: number;
  showOTP: boolean = false;

  constructor(private fb: FormBuilder, private http: HttpClient, private route: Router, private deviceService: DeviceDetectorService,
    private Toaster: ToastrService, private Localstorage: LocalStorageService, private aroute: ActivatedRoute) {
  }


  ngOnInit(): void {
    this.initialValue = this.formmaster.value;

  }

  public formmaster = this.fb.group({
    UserID: [0, [Validators.required]],
    UserName: ['', [Validators.required, Validators.email, Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')]],
    password: ['', [Validators.required, Validators.minLength(8), Validators.maxLength(20), Validators.pattern('^[a-zA-Z0-9!@#$%^&*()]*$')]],
    confirmpassword: ['', [Validators.required, Validators.minLength(8), Validators.maxLength(20), Validators.pattern('^[a-zA-Z0-9!@#$%^&*()]*$')]],
    OTP: ['', [Validators.required, Validators.minLength(4), Validators.maxLength(4)]],
    Email: ['', [Validators.required, Validators.email]]
  });

  // For validating form
  // validateform() {
  //   var Status = true;
  //   this.formmaster.markAllAsTouched();
  //   if (this.formmaster.valid) {
  //     Status = true;
  //   }
  //   else {
  //     Status = false;
  //   }
  //   return Status
  // }

  StartTimer() {
    this.remainingTime = (5 * 60 * 1000); // 2 minute from now

    // Update the remaining time every second
    const interval = setInterval(() => {
      const totalSeconds = Math.floor(this.remainingTime / 1000);
      this.remainingTime = this.remainingTime - 1000;
      this.minutes = Math.floor(totalSeconds / 60); // Calculate number of minutes
      this.seconds = totalSeconds % 60;

      // Check if time is up
      if (this.remainingTime < 0) {
        clearInterval(interval);
        this.remainingTime = 0;
      }
    }, 1000);
  }

  // For validating user
  validateUser() {
    // if (this.validateform()) {
    var Data = {
      "UserID": this.formmaster.get("UserID").value,
      "UserName": this.formmaster.get("UserName").value,
      "OTP": this.formmaster.get("OTP").value,
      "Email": this.formmaster.get("Email").value,
      "Op": 1
    };
    let headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    let options = {
      headers: headers
    }
    let body = JSON.stringify(Data);
    this.http.post(environment.apiurlcore + 'api/auth/get_otp', body, options).
      subscribe(
        (data: any) => {
          if (data.Status) {
            this.Toaster.info(data.Message, "", { timeOut: 5000 });
            this.opd = 1;
            this.StartTimer();
            this.formmaster.patchValue({ UserID: data.Data.UserID, OTP: '' })
            this.showOTP = true;

          } 
          else {
            if (data.Value == 2) {
              this.formmaster.patchValue({ UserID: data.Data.UserID });
              this.Toaster.error(data.Message, "", { timeOut: 2000 });
              this.showOTP = true;
              this.StartTimer();
            }
            else {
              this.showOTP = false;
              this.Toaster.error(data.Message, "", { timeOut: 2000 });
            }
          }
        },
        (error: any) => {
          this.Toaster.error("An error occurred while processing your request", "", { timeOut: 5000 });
        }
      );
    // }
  }

  // For validating otp
  validateOtp() {
    // if (this.validateform()) {
    var Data = {
      "UserID": this.formmaster.get("UserID").value,
      "UserName": this.formmaster.get("UserName").value,
      "OTP": this.formmaster.get("OTP").value,
      "Op": 2
    };
    let headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    let options = {
      headers: headers
    }
    let body = JSON.stringify(Data);
    this.http.post(environment.apiurlcore + 'api/auth/verify_otp', body, options).
      subscribe(
        (data: any) => {
          this.showOTP = true;
          if (data[0].success === 1) {
            // OTP verified successfully
            this.Toaster.success(data[0].msg, "", { timeOut: 5000 });
            this.opd = 2;
          } else if (data[0].success === 2) {
            // OTP is expired
            this.Toaster.warning(data[0].msg, "", { timeOut: 5000 });

          } else {
            // Invalid OTP
            this.Toaster.error(data[0].msg, "", { timeOut: 5000 });

          }
        },
        (error: any) => {
          this.Toaster.error("An error occurred while processing your request", "", { timeOut: 5000 });
        }
      );
    // }
  }

  onClick(type) {
    if (type == 1) {
      this.show1 = !this.show1;
    }
    if (type == 2) {
      this.show2 = !this.show2;
    }
  }

  // For reset password
  resetPassword() {
    // if (this.validateform()) {
    var Data = {
      "UserID": this.formmaster.get("UserID").value,
      "UserName": this.formmaster.get("UserName").value,
      "Password": this.formmaster.get("password").value,
      "Op": 3
    };
    let headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    let options = {
      headers: headers
    }
    let body = JSON.stringify(Data);
    this.http.post(environment.apiurlcore + 'api/auth/resetpassword', body, options).
      subscribe(
        (data: any) => {
          if (data[0].success == 1) {
            this.Toaster.success(data[0].msg, "", { timeOut: 5000 });
            this.route.navigate(['/auth/login']);

          } else {
            this.Toaster.error(data[0].msg, "", { timeOut: 5000 });
          }
        },
        (error: any) => {
          this.Toaster.error("An error occurred while processing your request", "", { timeOut: 5000 });
        }
      );
    // }
  }

  resendOtp() {
    this.validateUser();
  }
}
